document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-homepage-product-video]').forEach((section) => {
    const video = section.querySelector('video');
    const toggle = section.querySelector('.ta-homepage-product-video__toggle');
    const source = video?.querySelector('source');

    if (!(video instanceof HTMLVideoElement) || !(toggle instanceof HTMLButtonElement) || !(source instanceof HTMLSourceElement)) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');

    const syncMedia = () => {
      const useMobileMedia = mobileQuery.matches;
      const nextSource = useMobileMedia ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const nextType = useMobileMedia ? video.dataset.mobileType : video.dataset.desktopType;
      const nextPoster = useMobileMedia ? video.dataset.mobilePoster : video.dataset.desktopPoster;

      if (!nextSource || !nextType || !nextPoster) return;

      video.poster = nextPoster;

      if (video.dataset.activeSource === nextSource) return;

      video.pause();
      source.src = nextSource;
      source.type = nextType;
      video.dataset.activeSource = nextSource;
      video.load();
    };

    const updatePlayerState = () => {
      const isPlaying = !video.paused && !video.ended;
      section.classList.toggle('is-playing', isPlaying);
      toggle.setAttribute('aria-pressed', String(isPlaying));
      toggle.setAttribute('aria-label', isPlaying ? section.dataset.pauseLabel : section.dataset.playLabel);
    };

    toggle.addEventListener('click', async () => {
      if (video.paused || video.ended) {
        if (video.ended) video.currentTime = 0;

        try {
          await video.play();
        } catch {
          updatePlayerState();
        }
      } else {
        video.pause();
      }
    });

    video.addEventListener('play', updatePlayerState);
    video.addEventListener('pause', updatePlayerState);
    video.addEventListener('ended', () => {
      updatePlayerState();
    });

    syncMedia();
    mobileQuery.addEventListener('change', syncMedia);
  });
});
